import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconRefresh",
  "use": "IconRefresh-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"IconRefresh\"><path d=\"M7.33.734A6.313 6.313 0 001.645 4.9a.146.146 0 01-.158.095L.5 4.847a.3.3 0 00-.283.124.292.292 0 00-.012.31l1.563 2.741a.292.292 0 00.458.062l2.2-2.185a.292.292 0 00-.163-.496l-1-.149a.146.146 0 01-.113-.204 4.818 4.818 0 114.589 6.76.73.73 0 10.026 1.46h.028A6.27 6.27 0 107.33.734V.734z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol